import React, { useEffect } from "react";
import Footer from "../../Shared/Footer/Footer";
import NavigationBar from "../../Shared/NavigationBar/NavigationBar";
import ConnectCutomerServices from "../ConnectCutomerServices/ConnectCutomerServices";
import InnovativeWebsite from "../ConnectCutomerServices/InnovativeWebsite";
import Galary from "../Galary/Galary";
import HomeBanner from "../HomeBanner.js/HomeBanner";
import OfferDepartments from "../OfferDepartment/OfferDepartments";
import ReviewCutomers from "../ReviewCutomers/ReviewCutomers";
import Rules from "../Rules/Rules";
import Services from "../Services/Services";
import UsignTechnology from "../UsingTechnology/UsignTechnology";
import ValuableClients from "../ValuableClients/ValuableClients";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <NavigationBar />
      <HomeBanner />
      <OfferDepartments />
      <ConnectCutomerServices />
      <InnovativeWebsite />
      <Services />
      <ValuableClients />
      <Galary />
      <ReviewCutomers />
      <Rules />
      <UsignTechnology />
      <Footer />
    </div>
  );
};

export default Home;
